/* [DV-ROZET 2026-08-04] Fiyat rozetleri — ürün sayfası görsel katmanı.
   Veri: dv-rozet-data.js (window.__DV_ROZET__, sunucuda dvRozet.js üretir).
   GERÇEKLİK: rozetler sunucuda kayıtlı fiyat geçmişi + aktif fırsat
   kampanyalarından hesaplanır; bu dosya YALNIZ gösterir. Veri 48 saatten
   eskiyse hiçbir rozet gösterilmez (fail-closed). Fiyata/sepete dokunmaz. */
(function () {
  'use strict';
  if (window.__DV_ROZET_UI__) return;
  window.__DV_ROZET_UI__ = true;
  if (location.pathname.indexOf('/products/') === -1) return;

  var BAYAT_MS = 48 * 60 * 60 * 1000;

  var METIN = {
    sup: 'Süper Avantajlı Ürün',
    avn: 'Avantajlı Ürün',
    end7: 'Son 7 günün en düşük fiyatı',
    end14: 'Son 14 günün en düşük fiyatı',
    end30: 'Son 30 günün en düşük fiyatı'
  };
  var IPUCU = {
    sup: 'Aktif kampanya indirimi %30 ve üzeri; fiyat, kayıtlı fiyat geçmişimizdeki en düşük seviyede.',
    avn: 'Aktif kampanya indirimi %15 ve üzeri.',
    end7: 'Kayıtlı fiyat geçmişimize göre bu fiyat son 7 günün en düşüğüdür.',
    end14: 'Kayıtlı fiyat geçmişimize göre bu fiyat son 14 günün en düşüğüdür.',
    end30: 'Kayıtlı fiyat geçmişimize göre bu fiyat son 30 günün en düşüğüdür.'
  };

  function stilEkle() {
    if (document.getElementById('dv-rozet-stil')) return;
    var s = document.createElement('style');
    s.id = 'dv-rozet-stil';
    s.textContent =
      '#dv-rozetler{display:flex;flex-wrap:wrap;gap:8px;margin:10px 0 2px;}' +
      '.dv-rozet{display:inline-flex;align-items:center;gap:5px;padding:4px 10px;' +
      'border-radius:6px;font-size:12px;font-weight:650;line-height:1.2;' +
      'font-family:Inter,ui-sans-serif,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;}' +
      '.dv-rozet--sup{color:#fff;background:#d74800;}' +
      '.dv-rozet--avn{color:#d74800;background:#fff;border:1px solid #d74800;}' +
      '.dv-rozet--end{color:#1a7f37;background:#e7f5ec;}' +
      '@media(max-width:767px){.dv-rozet{font-size:11px;padding:3px 8px;}}';
    document.head.appendChild(s);
  }

  function seciliVid() {
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (m && m.selectedVariantId) return String(m.selectedVariantId);
      var u = new URLSearchParams(location.search).get('variant');
      if (u) return String(u);
      var f = document.querySelector('form[action^="/cart/add"] [name="id"]');
      if (f && f.value) return String(f.value);
      if (m && m.product && m.product.variants && m.product.variants.length === 1) {
        return String(m.product.variants[0].id);
      }
    } catch (e) {}
    return null;
  }

  function hedefKutu() {
    return document.querySelector('.dv-fixed-option3__pricing') ||
      document.querySelector('.dv-fixed-option3__header') ||
      document.querySelector('.hdt-product__price, .hdt-price');
  }

  function ciz() {
    var d = window.__DV_ROZET__;
    var eski = document.getElementById('dv-rozetler');
    if (!d || !d.varyant) { if (eski) eski.remove(); return; }
    var gen = Date.parse(d.gen || '');
    if (!isFinite(gen) || Date.now() - gen > BAYAT_MS) { if (eski) eski.remove(); return; }

    var vid = seciliVid();
    var kayit = vid && d.varyant[vid];
    if (!kayit || !kayit.r || !kayit.r.length) { if (eski) eski.remove(); return; }

    var kutu = hedefKutu();
    if (!kutu) return;
    stilEkle();

    var kap = eski || document.createElement('div');
    kap.id = 'dv-rozetler';
    kap.innerHTML = '';
    /* [DV-INDIRIM-SOZLESME 2026-08-26] "Son X gunun en dusuk fiyati" TEK YERDE gosterilir.
       option3 sayfasinda fiyatin altindaki satir bu iddiayi RAKAMIYLA yaziyor; burada
       tekrar pill basmak ayni iddiayi iki kez gosterirdi. Avantajli/Super pill'leri kalir. */
    var min30Satiri = document.querySelector('[data-dv-fixed-min30]');
    var SIRA = min30Satiri ? ['sup', 'avn'] : ['sup', 'avn', 'end30', 'end14', 'end7'];
    for (var i = 0; i < SIRA.length; i++) {
      var k = SIRA[i];
      if (kayit.r.indexOf(k) === -1) continue;
      var el = document.createElement('span');
      el.className = 'dv-rozet ' + (k === 'sup' ? 'dv-rozet--sup' : k === 'avn' ? 'dv-rozet--avn' : 'dv-rozet--end');
      el.textContent = METIN[k];
      el.title = IPUCU[k];
      kap.appendChild(el);
    }
    if (!kap.children.length) { kap.remove(); return; }
    if (!eski) kutu.appendChild(kap);
  }

  function kur() {
    ciz();
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.type === 'radio')) {
        setTimeout(ciz, 120);
      }
    }, true);
    /* URL variant parametresi degisimi (tema history push yapar) */
    var sonUrl = location.search;
    setInterval(function () {
      if (location.search !== sonUrl) { sonUrl = location.search; ciz(); }
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur);
  } else {
    kur();
  }
})();
